import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/app/shared/shared.module';
import { ServiceRequestAddAgentComponent } from './components/service-request-add-agent/service-request-add-agent.component';
import { ServiceRequestDetailsComponent } from './components/service-request-details/service-request-details.component';
import { ServiceRequestComponent } from './components/service-request.component';
import { ServiceRequestRoutingModule } from './service-request-routing.module';
import { ServiceRequestService } from './service-request.service';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ServiceRequestRoutingModule,
    SharedModule,
  ],
  declarations: [
    ServiceRequestComponent,
    ServiceRequestDetailsComponent,
    ServiceRequestAddAgentComponent
  ],
  exports: [
    ServiceRequestComponent,
    ServiceRequestDetailsComponent
  ],
  providers: [
    ServiceRequestService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ServiceRequestModule { }
